/** @jsx jsx */
import { jsx } from "theme-ui"

const ExternalLinkIcon = ({ color }) => (
  // viewBox is tightened to the actual glyph bounds (originally the path had
  // transform="translate(-4 -3.793)" inside a 0 0 24 24 viewBox, which left
  // ~⅓ of the box empty on the right and bottom — making any CSS centering
  // visually wrong). The path is unmodified; only the viewBox crops the
  // empty padding so the glyph fills the rendered span.
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="4 3.8 14.7 14.9"
  >
    <path
      id="Icon_feather-external-link"
      data-name="Icon feather-external-link"
      d="M16.167,12.278v4.667A1.556,1.556,0,0,1,14.611,18.5H6.056A1.556,1.556,0,0,1,4.5,16.944V8.389A1.556,1.556,0,0,1,6.056,6.833h4.667M13.833,4.5H18.5V9.167M9.944,13.056,18.5,4.5"
      fill="none"
      stroke={color || "#fff"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
)

export default ExternalLinkIcon
